import { render, staticRenderFns } from "./Scene.vue?vue&type=template&id=5c77cccd&scoped=true"
import script from "./Scene.vue?vue&type=script&lang=js"
export * from "./Scene.vue?vue&type=script&lang=js"
import style0 from "./Scene.vue?vue&type=style&index=0&id=5c77cccd&prod&scoped=true&lang=css"
import style1 from "./Scene.vue?vue&type=style&index=1&id=5c77cccd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c77cccd",
  null
  
)

export default component.exports